import { render, staticRenderFns } from "./TxSimple.vue?vue&type=template&id=992105a4"
import script from "./TxSimple.vue?vue&type=script&lang=js"
export * from "./TxSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports